import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Icon from 'app/ui_components/Icon';
import Donut from 'app/ui_components/Donut';

const Container = styled.div`
  position: relative;
`;

const Absolute = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
`;

const DIMENSION = 75;

const IconWithDonut = ({ graphic, percentage }) => (
  <Container>
    <Icon graphic={graphic} dimension={DIMENSION} />
    <Absolute>
      <Donut percentage={percentage} dimension={DIMENSION} />
    </Absolute>
  </Container>
);

IconWithDonut.propTypes = {
  graphic: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
};

export default IconWithDonut;
